<div *ngIf="Menu_Vial_ScriptManagement === true && machinePermissionsMAX === true">
  <app-vial-scripting></app-vial-scripting>
</div>
<div *ngIf="Menu_Pouch_ScriptManagement === true  && machinePermissionsATP === true">
  <app-pouch-scripting ></app-pouch-scripting>
</div>